import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { adoptHandoffToken } from "./lib/api";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "./index.css";

// Adopt a token handed off from the staff Console (#token=...) before render,
// so RequireAuth sees an authenticated session and lands on /atlas.
adoptHandoffToken();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
